import { Table, Tabs, Input, Button, Pagination, message, Popconfirm, Tooltip, TreeSelect, Select, Modal, Form, InputNumber } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { resourceList, resourceUpdate, auditorList, evaluate } from "@/apis/audit"
import { useEffect } from 'react';
import publicImg from "@/assets/images/discover/public.png";
import unpublic from "@/assets/images/discover/unpublic.png";
import computable from "@/assets/images/discover/computable.png";
import React from 'react';
import DownloadPolicyModal from './DownloadPolicyModal';

let typeList = []
let columns = []
const { TextArea } = Input;

const DataAuditing = () => {
	const [auditList, setAuditList] = useState([])
	const [downloadPolicyResource, setDownloadPolicyResource] = useState(null);
	const [isOpen, setIsOpen] = useState(false)
	const [resourceId, setResourceId] = useState("")
	const [form] = Form.useForm();
	const [isGradeOpen, setIsOpenGrade] = useState(false)
	const [gradeForm] = Form.useForm();
	const [params, setParams] = useState({
		keywords: "",
		auditStatus: 1,
		secondType: "",
		auditor: ""
	})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [data, setData] = useState([]);
	const [total, setTotal] = useState(0)

	const onFinishGrade = (values) => {
		evaluate({
			resourceUuid: resourceId,
			points: values.points,
			validSampleNum: values.validSampleNum
		}).then(res => {
			setIsOpenGrade(false)
			audit(resourceId, 2, "")
		}).catch()
	}

	useEffect(() => {
		columns = [
			{
				title: "序号",
				key: 'index',
				width: 72,
				align: 'center',
				render: (text, record, index) => (pageParam.currentPage - 1) * pageParam.pageSize + index + 1,
			},
			{
				title: "标题",
				dataIndex: 'title',
				key: 'title',
				width: 300,
				render: (text, record, index) => (
					<Tooltip placement="rightTop" styles={{
						root: { maxWidth: 600 }
					}} title={record.description}>
						<a target="_blank" href={`${process.env.PUBLIC_URL}/discover/detail?id=${record.resourceUuid}`}>{text}</a>
					</Tooltip>
				),
			},
			{
				title: "资源类型",
				key: 'resourceType',
				dataIndex: 'resourceType',
				width: 280,
				render: (text, record) => (
					<div>{changeResouece(record.firstType, record.secondType)}</div>
				),
			},
			{
				title: '资源属性',
				key: 'icon_bar',
				width: 130,
				render: (text, record, index) => (
					<div className={styles.iconBox}>
						{record.resourceType && <Tooltip title={record.resourceType.typeName}>
							<img src={process.env.REACT_APP_API_AFFIX + record.resourceType.imgPath} />
						</Tooltip>}
						{
							(record.secondType !== "OpenDataServices" && record.secondType !== "OpenProcessServices" && record.secondType !== "OpenWebApps") &&
							<Tooltip title={record.isDownloadable ? 'Downloadable' : 'Not downloadable'}>
								<img src={record.isDownloadable ? publicImg : unpublic} />
							</Tooltip>
						}
						{record.isComputable &&
							<Tooltip title={"Computable"}>
								<img src={computable} />
							</Tooltip>
						}
					</div>
				),
			},
			{
				title: "贡献者",
				dataIndex: 'contributor',
				key: 'Contributor',
				width: 140,
				render: (text, record) => (
					<div>{(record.contributors && record.contributors.length > 0) ? record.contributors[0].nickname : ""}</div>
				),
			},

			{
				title: "数据来源",
				dataIndex: 'dataSource',
				key: 'dataSource',
				width: 100,
				render: (text, record) => (
					<div>{record.dataSource === "Wuhan-1 Satellite Sample" ? "武汉一号" : "其他"}</div>
				),
			},
			{
				title: params.auditStatus === 1 ? "提交审核时间" : "审核时间",
				dataIndex: 'auditTime',
				key: 'auditTime',
				width: 170,
			},
			{
				title: "操作",
				key: 'opreation',
				width: 260,
				align: 'center',
				fixed: 'right',
				render: (text, record) => {
					return <div className={styles.rowActions}>
						<Popconfirm
							title="审核驳回"
							description="是否确认继续执行此操作?"
							onConfirm={() => reject(record.resourceUuid)}
							okText="是"
							cancelText="否"
						>
							{(params.auditStatus === 1 || params.auditStatus === 2) && <Button size="small">驳回</Button>}
						</Popconfirm>
						<Popconfirm
							title="审核通过"
							description="是否确认继续执行此操作?"
							onConfirm={() => pass(record.resourceUuid, 2, record.dataSource)}
							okText="是"
							cancelText="否"
						>
							{(params.auditStatus === 1 || params.auditStatus === 3) && <Button type="primary" size="small">通过</Button>}
						</Popconfirm>
						<Button size="small" onClick={() => setDownloadPolicyResource(record)}>下载权限</Button>
					</div>
				},
			},
		];

		if (params.auditStatus === 1) {
			columns = columns.filter(item => item.key !== 'auditor')
		} else if (params.auditStatus === 2 || params.auditStatus === 3) {
			columns.splice(5, 0, {
				title: "审核人",
				dataIndex: 'auditor',
				key: 'auditor',
				width: 120,
				render: (text, record) => (
					<div>{record.auditor ? record.auditor.nickname : ""}</div>
				),
			})
			if (params.auditStatus === 3) {
				columns.splice(7, 0, {
					title: "驳回原因",
					dataIndex: 'auditMessage',
					key: 'auditMessage',
					width: 180,
					render: (text, record, index) => (
						<Tooltip placement="rightTop" title={text}>
							<div className={styles.msgBox}>{text}</div>
						</Tooltip>
					),
				})
			}
		}
	}, [params.auditStatus, pageParam.currentPage, pageParam.pageSize])

	const items = [
		{
			key: 1,
			label: '待审核',
			children: '',
		}, {
			key: 2,
			label: '审核通过',
			children: '',
		}, {
			key: 3,
			label: '审核不通过',
			children: '',
		}
	];

	const reject = (id) => {
		setIsOpen(true)
		setResourceId(id)
		form.setFieldsValue({
			auditMessage: "",
		})
	}

	const pass = (id, status, dataSource) => {
		if (dataSource !== "Wuhan-1 Satellite Sample") {
			audit(id, status, "")
		} else {
			setResourceId(id)
			setIsOpenGrade(true)
			gradeForm.setFieldsValue({
				points: "",
			})
		}
	}

	// 审核
	const audit = (id, status, msg) => {
		resourceUpdate({
			resourceUuid: id,
			auditStatus: status,
			auditMessage: msg
		}).then(res => {
			message.success('审核成功')
			getList()
			if (status === 3) {
				setIsOpen(false)
			}
		}).catch(err => { })
	}

	const onChange = (key) => {
		setParams({ ...params, auditStatus: key, auditor: '' })
		setPageParam({ ...pageParam, currentPage: 1 })
	}

	const getList = () => {
		resourceList({
			pageParam: pageParam,
			...params,
		}).then(res => {
			setData(res.data?.records || [])
			setTotal(res.data?.total || 0)
		}).catch(err => { })
	}
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			getList()
		}
	}
	useEffect(() => {
		fetch('/share.json')
			.then(response => response.json())
			.then(jsonData => {
				typeList = jsonData.typeList
				typeList.forEach(item => {
					if (item.children && item.children.length > 0) {
						item.disabled = true
					}
				})
			})
			.catch(error => console.error('Error fetching data:', error));

		auditorList().then(res => {
			const arr = res.data.map(item => {
				return {
					label: item.username,
					value: item.uuid
				}
			})
			setAuditList(arr)
		}).catch(err => { })
	}, []);

	useEffect(() => {
		getList()
	}, [params, pageParam])

	const changeResouece = (firstType, secondType) => {
		if (typeList.length > 0) {
			const arr = typeList.filter(item => item.value === firstType)
			const arr2 = arr[0].children.filter(item => item.value === secondType)
			return `【${arr[0].label}】${arr2[0].label}`
		} else {
			return ""
		}
	}

	const onFinish = (values) => {
		audit(resourceId, 3, values.auditMessage)
	}

	return <div className={classNames('container', styles.dataAuditingBox)}>
		<h3>资源审核</h3>
        <DownloadPolicyModal resource={downloadPolicyResource} onClose={() => setDownloadPolicyResource(null)} />
		<Tabs type="card" defaultActiveKey={params.auditStatus} items={items} onChange={onChange} />
		<div className={styles.paramBox}>
			<span>标题：</span>
			<Input
				allowClear
				placeholder="资源名称"
				onKeyDown={handleKeyDown}
				className={styles.itemBox}
				onChange={(e) => {
					setParams({ ...params, keywords: e.target.value })
				}} />

			<span>资源类型：</span>
			<TreeSelect
				showSearch
				style={{
					width: '300px',
				}}
				value={params.secondType}
				fieldNames={{ label: 'label', value: 'value', children: 'children' }}
				placeholder="请选择"
				allowClear
				treeDefaultExpandAll={true}
				onChange={(e) => {
					setParams({ ...params, secondType: e })
				}}
				treeData={typeList}
			/>
			{
				params.auditStatus !== 1 && <React.Fragment>
					<span style={{ marginLeft: 20 }}>审核人：</span>
					<Select
						allowClear
						showSearch
						style={{ width: 220 }}
						options={auditList}
						optionFilterProp="label"
						onChange={(value) => {
							setParams({ ...params, auditor: value })
						}}
					>
					</Select>
				</React.Fragment>
			}
		</div>
		<Table className={styles.resourceTable} rowKey={record => record.resourceUuid} pagination={false} columns={columns} dataSource={data} tableLayout="fixed" scroll={{ x: 1600 }} />
		<Pagination
			align="end"
			style={{ marginTop: "20px" }}
			current={pageParam.currentPage}
			pageSize={pageParam.pageSize}
			total={total}
			showSizeChanger={false}
			showQuickJumper
			onChange={(page, pageSize) => {
				setPageParam({
					currentPage: page,
					pageSize: pageSize,
				});
			}}
		/>

		{/*驳回原因*/}
		<Modal
			title="驳回原因"
			width={500}
			open={isOpen}
			maskClosable={false}
			footer={null}
			onCancel={() => {
				setIsOpen(false)
			}}>
			<Form
				onFinish={onFinish}
				layout="vertical"
				autoComplete="off"
				form={form}
				style={{ marginTop: 40 }}
			>
				<Form.Item
					name="auditMessage"
					rules={[
						{
							required: true,
							message: "请输入驳回原因！",
						}
					]}
				>
					<TextArea rows={4} placeholder="请输入驳回原因" />
				</Form.Item>
				<Form.Item style={{ "marginTop": "40px" }}>
					<Button type="primary" htmlType="submit">
						提交
					</Button>
				</Form.Item>
			</Form>
		</Modal>

		{/*打分*/}
		<Modal
			title="打分"
			width={500}
			open={isGradeOpen}
			maskClosable={false}
			footer={null}
			onCancel={() => {
				setIsOpenGrade(false)
			}}>
			<Form
				onFinish={onFinishGrade}
				layout="horizontal"
				autoComplete="off"
				form={gradeForm}
				labelAlign="right"
				wrapperCol={{ flex: 1 }}
				style={{ marginTop: 40 }}
				labelCol={{ flex: '110px' }}
			>
				<Form.Item
					name="points"
					label="积分值"
					rules={[
						{
							required: true,
							message: "请输入奖励积分！",
						}
					]}
				>
					<InputNumber style={{ width: "100%" }} min={0} />
				</Form.Item>
				<Form.Item
					name="validSampleNum"
					label="符合要求的样本数"
					rules={[
						{
							required: true,
							message: "请输入符合要求的样本数！",
						}
					]}
				>
					<InputNumber style={{ width: "100%" }} min={0} />
				</Form.Item>
				<Form.Item style={{ "marginTop": "40px" }}>
					<Button type="primary" htmlType="submit">
						提交
					</Button>
				</Form.Item>
			</Form>
		</Modal>

	</div>
}
export default DataAuditing;